
import React from 'react';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '@/components/ui/collapsible';
import { Button } from '@/components/ui/button';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { BonusInsightItemProps } from './types';
import { formatInsightName } from './utils';
import { InsightIcon } from './InsightIcon';
import { NewFormatInsight } from './NewFormatInsight';
import { LegacyFormatInsight } from './LegacyFormatInsight';
import { isNewBonusFormat } from '@/utils/bonus-section';

export const BonusInsightItem: React.FC<BonusInsightItemProps> = ({ 
  insightKey, 
  bonusSection, 
  openItem, 
  toggleItem 
}) => {
  return (
    <Collapsible 
      key={insightKey}
      open={openItem === insightKey}
      onOpenChange={() => toggleItem(insightKey)}
      className="border rounded-lg overflow-hidden"
    >
      <div className="flex justify-between items-center p-4 cursor-pointer bg-muted/30 hover:bg-muted/50 transition-colors">
        <div className="flex items-center">
          <InsightIcon insightKey={insightKey} />
          <span className="font-medium">{formatInsightName(insightKey)}</span>
        </div>
        <CollapsibleTrigger asChild>
          <Button variant="ghost" size="sm">
            {openItem === insightKey ? (
              <ChevronUp className="h-4 w-4" />
            ) : (
              <ChevronDown className="h-4 w-4" />
            )}
          </Button>
        </CollapsibleTrigger>
      </div>
      
      <CollapsibleContent>
        <div className="p-4 pt-0 border-t">
          {isNewBonusFormat(bonusSection) 
            ? <NewFormatInsight insightKey={insightKey} bonusSection={bonusSection} />
            : <LegacyFormatInsight insightKey={insightKey} bonusSection={bonusSection} />
          }
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};
